import moment from 'moment-timezone'
import { mapGetters } from 'vuex'

export default {
  methods: {
    buildEndTimes(graphData, secondLastDataItem, lastDataItem) {
      if (graphData.length < 1) { return }

      const graphDataLength = graphData.length,
        lastGraphDataItem = graphData[graphDataLength - 1]
      let endTime = moment.utc().add(1, 'hours')
      if (graphDataLength > 1) {
        const secondLastTimeKey = this.getFirstKeyFromObject(secondLastDataItem),
          lastTimeKey = this.getFirstKeyFromObject(lastDataItem),
          secondLastStartTime = moment.utc(secondLastTimeKey, 'YYYY-MM-DD HH:mm:ss'),
          lastStartTime = moment.utc(lastTimeKey, 'YYYY-MM-DD HH:mm:ss'),
          hourDiff = lastStartTime.diff(secondLastStartTime, 'hours'),
          finalEndTime = lastStartTime.add(hourDiff, 'hours')

        if (moment.utc().diff(finalEndTime) >= 0) { endTime = finalEndTime }
      }
      lastGraphDataItem.final_end_time = this.formatDateTime(endTime)
      return graphData
    },

    buildGraphData(data, graphType) {
      if (graphType === 'occurring') { return data; }

      let graphData = this.createMainGraphData(data)

      const dataLength = data?.length,
        secondLastDataItem = dataLength > 1 ? data[dataLength - 2] : null,
        lastDataItem = dataLength ? data[dataLength - 1] : null

      return this.buildEndTimes(graphData, secondLastDataItem, lastDataItem)
    },

    configureDisplayDate(momentDateTime) {
      let displayDate = this.merchantTimeZone ? momentDateTime.tz(this.merchantTimeZone) : momentDateTime,
        shortTime = displayDate.hour() > 11 ? `${displayDate.format('h')}p` : `${displayDate.format('h')}a`,
        shortDate = displayDate.format('M/D')
      return `${shortDate} ${shortTime}`
    },

    createDateTicks(max, min, timeIncrement, timeType) {
      let incrementDate = min.clone(),
        ticks = []
      while (incrementDate.isBefore(max)) {
        ticks.push(this.configureDisplayDate(incrementDate))
        incrementDate = incrementDate.clone().add(timeIncrement, timeType)
      }
      return ticks
    },

    createMainGraphData(data) {
      let graphData = []
      data.forEach((item) => {
        let itemKey = this.getFirstKeyFromObject(item),
          chartItem = item[itemKey],
          isAlreadyObject = typeof chartItem === 'object' && !!chartItem
        if (!isAlreadyObject) {
          chartItem = { amount: !!chartItem ? chartItem : 0 }
        }
        chartItem.date_time = this.formatDateTime(itemKey)
        graphData.push(chartItem)
      })
      return graphData
    },

    formatDateTime(dateTime) {
      return this.configureDisplayDate(moment.utc(dateTime, 'YYYY-MM-DD HH:mm:ss'))
    },

    getFirstKeyFromObject(item) {
      return Object.keys(item)[0]
    },

    getStartEndDates(data, graphType) {
      const isTrends = graphType === 'trends'
      if (isTrends && data.length > 12) {
        let momentDateTimes = []

        data.forEach((item) => momentDateTimes.push(moment.utc(Object.keys(item)[0], 'YYYY-MM-DD HH:mm:ss')) )

        const maxDate = moment.max(momentDateTimes),
          minDate = moment.min(momentDateTimes)

        if (data.length > 12) {
          const range = moment.duration(maxDate.diff(minDate)),
            timeIncrement = range.asSeconds() / 11
          this.$set(this[graphType], 'dateTicks', this.createDateTicks(maxDate, minDate, timeIncrement, 'seconds'))
        }
      } else if (isTrends && this[graphType].dateTicks) {
        this.$delete(this[graphType], 'dateTicks')
      }
    },
  },

  mounted() {
    this.setWrapperWidths()
    window.addEventListener('resize', this.setWrapperWidths)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.setWrapperWidths)
  },

  computed: {
    ...mapGetters([
      'merchantTimeZone'
    ]),
  },
}